export function scrollToForm(): void {
  const target = document.getElementById('cotizar')
  if (!target) return
  target.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
